const S3_URL = import.meta.env.VITE_S3_URL;

type formatImagesProps = {
  id: string | number;
  path: string;
}[] | undefined

const formatImages = (images: formatImagesProps) => {
  if(!images || images.length < 1) {
    return [];
  }

  return images.map((img)=> img.path ? `${S3_URL}${img.path}` : "" );
}

export default formatImages